// The API sends `releaseAt` as an instant ("2026-08-12T13:00:00Z"), shown on the customer's own
// calendar. The admin form works in calendar days ("2026-08-12"), which are read from their date part
// so no timezone moves them into the day, or the month, before.
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const toLocalDay = (release) => {
    if (!DATE_ONLY.test(release))
        return new Date(release);
    const [year, month, day] = release.split("-").map(Number);
    return new Date(year, month - 1, day);
};
/** "Aug 12, 2026"; an em dash when there is no date yet. */
const formatNotificationReleaseDate = (releaseDate) => {
    if (!releaseDate)
        return "—";
    return toLocalDay(releaseDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
/**
 * The drawer's sections (FR-5): This month, Last month, Earlier this year, then one per older year,
 * then undated ones. Items keep the order the API sent them in (high priority first, then newest), so
 * a high-priority announcement goes to its own section rather than opening a new one at the top.
 */
const groupNotificationsByRelease = (items, now = new Date()) => {
    const thisMonth = now.getFullYear() * 12 + now.getMonth();
    /** The section's label and where it goes: lower comes first. */
    const sectionOf = (item) => {
        if (!item.releaseAt)
            return { label: "Earlier", rank: Number.MAX_SAFE_INTEGER };
        const released = toLocalDay(item.releaseAt);
        const month = released.getFullYear() * 12 + released.getMonth();
        if (month >= thisMonth)
            return { label: "This month", rank: 0 };
        if (month === thisMonth - 1)
            return { label: "Last month", rank: 1 };
        if (released.getFullYear() === now.getFullYear())
            return { label: "Earlier this year", rank: 2 };
        return { label: String(released.getFullYear()), rank: 3 + now.getFullYear() - released.getFullYear() };
    };
    const sections = new Map();
    items.forEach((item) => {
        var _a;
        const { label, rank } = sectionOf(item);
        const section = (_a = sections.get(label)) !== null && _a !== void 0 ? _a : { label, rank, items: [] };
        section.items.push(item);
        sections.set(label, section);
    });
    return [...sections.values()]
        .sort((a, b) => a.rank - b.rank)
        .map(({ label, items: listed }) => ({ label, items: listed }));
};

export { formatNotificationReleaseDate, groupNotificationsByRelease };
